import React, { useState, useEffect } from 'react';
import {
  Box,
  Stack,
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const DescriptionSection = ({ initialDescription, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(initialDescription);
  const [originalDescription, setOriginalDescription] = useState(initialDescription);

  useEffect(() => {
    setDescription(initialDescription);
  }, [initialDescription]);

  const handleStartEditing = () => {
    setOriginalDescription(description);
    setIsEditing(true);
  };

  const handleSave = async () => {
    const success = await onSave({ description });
    if (success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setDescription(originalDescription);
    setIsEditing(false);
  };

  const transform = (node) => {
    // You can add custom transformations here if needed
    return node;
  };

  return (
    <Box sx={{ position: 'relative', mt: 2 }}>
      {isEditing ? (
        <>
          <ReactQuill
            value={description}
            onChange={setDescription}
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
              ],
            }}
          />
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <Box onClick={handleSave} sx={{ cursor: 'pointer', color: 'primary.main' }}>
                <DoneIcon sx={{ fontSize: '20px' }} />
              </Box>
              <Box onClick={handleCancel} sx={{ cursor: 'pointer', color: 'error.main' }}>
                <CloseIcon sx={{ fontSize: '20px' }} />
              </Box>
            </Box>
          </Stack>
        </>
      ) : (
        <>
          <Box
            sx={{
              border: '1px solid transparent',
              padding: 1,
              '&:hover': {
                borderColor: '#ddd',
                backgroundColor: '#f9f9f9',
                cursor: 'pointer',
              },
            }}
            onClick={handleStartEditing}
          >
            {parse(DOMPurify.sanitize(description || ''), { replace: transform })}
          </Box>
        </>
      )}
    </Box>
  );
};

export default DescriptionSection;
